module.exports = __webpack_public_path__ + "static/img/2415(3).4a205d5b.png";